
import users from '../api/users'

export const state = {
  users: [],
  teachers: [],
  user_pagination_data: {},
  user: ''
}

export const getters = {
  users: state => state.users,
  teachers: state => state.teachers,
  user_pagination_data: state => state.user_pagination_data,
  user: state => state.user
}

export const mutations = {
  ADD_USER (state, data) {
    state.users.push(data)
  },
  SET_USERS (state, data) {
    state.users = data
  },
  SET_TEACHERS (state, data) {
    state.teachers = data
  },
  SET_USER_PAGINATION (state, data) {
    state.user_pagination_data = data
  },
  SHOW_USER (state, data) {
    state.user = data
  }
}

export const actions = {
  GET_USERS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      users.get(data).then(response => {
        commit('SET_USERS', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_USER_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GET_TEACHERS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      users.getTeachers(data).then(response => {
        commit('SET_TEACHERS', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_USER ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      users.create(data).then(response => {
        commit('ADD_USER', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  CREATE_USER_FROM_INVITATION ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      users.createUserFromInvitation(data).then(response => {
        commit('ADD_USER', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_USER ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      users.show(id).then(response => {
        commit('SHOW_USER', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_USER ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      users.update(data, state.user.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_USER ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      users.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  GET_TEACHERS_DIRECTORY ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      users.getTeacherDirectory(data).then(response => {
        commit('SET_TEACHERS', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_USER_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js